"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactAddonsCreateFragment = require("react-addons-create-fragment");

var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);

var _reactRedux = require("react-redux");

var _redial = require("redial");

var _components = require("components");

var _NotFound = require("pages/NotFound/NotFound");

var _NotFound2 = _interopRequireDefault(_NotFound);

var _CookieNotice = require("@quixeltools/quixel-ui-library/dist/components/common/website/CookieNotice");

var _CookieNotice2 = _interopRequireDefault(_CookieNotice);

var _BridgeDownloadPopup = require("@quixeltools/quixel-ui-library/dist/components/common/website/BridgeDownloadPopup");

var _BridgeDownloadPopup2 = _interopRequireDefault(_BridgeDownloadPopup);

var _TopBanner = require("@quixeltools/quixel-ui-library/dist/components/megascans/marketing/TopBanner");

var _TopBanner2 = _interopRequireDefault(_TopBanner);

var _SubscribeNotice = require("@quixeltools/quixel-ui-library/dist/components/common/website/SubscribeNotice");

var _SubscribeNotice2 = _interopRequireDefault(_SubscribeNotice);

var _EpicPlansGotBetterBanner = require("../../EpicMigration/components/EpicPlansGotBetterBanner");

var _EpicPlansGotBetterBanner2 = _interopRequireDefault(_EpicPlansGotBetterBanner);

var _EpicLoginRedirectSensitiveOverlay = require("../../EpicMigration/components/EpicLoginRedirectSensitiveOverlay");

var _EpicLoginRedirectSensitiveOverlay2 = _interopRequireDefault(_EpicLoginRedirectSensitiveOverlay);

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _app = require("../../redux/modules/app");

var appActions = _interopRequireWildcard(_app);

var _hubspot = require("../../redux/modules/hubspot");

var _dialogs = require("utils/dialogs");

var _dialogs2 = _interopRequireDefault(_dialogs);

var _utils = require("utils");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = void 0;

var App = (_dec = (0, _redial.provideHooks)({
  defer: function defer(_ref) {
    var dispatch = _ref.store.dispatch,
        pathname = _ref.pathname,
        query = _ref.query;

    return dispatch(appActions.initializeApp({ location: { pathname: pathname, query: query } }));
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth,
    user: state.user,
    packs: state.packs.packs,
    notFound: state.request && state.request.status === 404,
    softwares: state.softwares
  };
}, { subscribeHubspot: _hubspot.subscribeHubspot }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App(props) {
    (0, _classCallCheck3.default)(this, App);

    var _this = (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).call(this, props));

    _this.state = {
      pageOffset: 0,
      _cookieNoticeDiscarded: true,
      promotionalPopupDiscard: true,
      os: "Mac",
      resetSubscription: true,
      previousIsArchviz: false,
      subscribed: false,
      _subscribe: false
    };
    _this.handlePromotionalPopupDiscard = _this.handlePromotionalPopupDiscard.bind(_this);
    _this.handleSubscribePopupDiscard = _this.handleSubscribePopupDiscard.bind(_this);
    _this.showSubscribe = _this.showSubscribe.bind(_this);
    _this.tellUsProgramPopup = _this.tellUsProgramPopup.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var platform = (0, _utils.detectOperatingSystem)();

      var os = platform.toLowerCase();
      // this.state.os!=='Windows'
      styles = os !== "windows" || typeof InstallTrigger === "undefined" ? require("./App.scss") : require("./App_os.scss");

      var _cookieNoticeDiscarded = window.localStorage.getItem("_cookieNoticeDiscarded");

      var subscribed = window.localStorage.getItem("subscribed");

      this.setState({ _cookieNoticeDiscarded: _cookieNoticeDiscarded, subscribed: subscribed });

      //Start: Tell us popup Implementaiton. Do not show on first login and if Info required show popup.
      if (this.props.user.isInfoRequired && this.props.auth.loggedIn) {
        var firstLogin = window.localStorage.getItem("firstLogin" + this.props.auth.user.email);

        if (firstLogin === "true") {
          //this.tellUsProgramPopup();
        } else {
          window.localStorage.setItem("firstLogin" + this.props.auth.user.email, true);
        }
      }
      //End: Tell us popup Implementaiton. Do not show on first login and if Info required show popup.

      var week = window.localStorage.getItem("week");
      var month = window.localStorage.getItem("month");

      if (week) {
        window.localStorage.setItem("week", week);
      } else {
        window.localStorage.setItem("week", 0);
      }

      if (month) {
        window.localStorage.setItem("month", month);
      } else {
        window.localStorage.setItem("month", 0);
      }

      if (!subscribed) this.subscribeInterval = setInterval(this.showSubscribe, 1000);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var dispatch = this.props.dispatch;
      var query = nextProps.location.query;
      var oldQuery = this.props.location.query;


      var newState = {};

      if (this.props.location.pathname !== nextProps.location.pathname) {
        this.setState({
          resetSubscription: nextProps.location.pathname
        });
      }
      if (this.props.location.key !== nextProps.location.key) {
        if (!(this.props.location.state && this.props.location.state.modal) && nextProps.location.state && nextProps.location.state.modal) {
          newState.pageOffset = _reactDom2.default.findDOMNode(this.refs.appWrap).getBoundingClientRect().top;

          // save the old children
          this.previousChildren = this.props.children;
          this.previousLocation = "" + this.props.location.pathname + this.props.location.search;
        } else if (!(nextProps.location.state && nextProps.location.state.modal)) {
          this.previousChildren = null;
          this.previousLocation = null;
        }
      }
      if (this.props.location.pathname !== nextProps.location.pathname) {
        if (this.props.location.pathname.length < 9 && this.props.location.pathname.indexOf("/archviz") !== -1) {
          this.setState({
            previousIsArchviz: true
          });
        }
      }

      this.setState(newState);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (prevState.dialogComponent && !this.state.dialogComponent || prevProps.location.key != this.props.location.key && prevProps.location.state && prevProps.location.state.modal && (!this.props.location.state || !this.props.location.state.modal)) {}
      //window.scrollTo(0, -this.state.pageOffset);

      //Start: Tell us popup Implementaiton. Do not show on first login and if Info required show popup.
      if (this.props.user.isInfoRequired !== prevProps.user.isInfoRequired && this.props.user.isInfoRequired && this.props.auth.loggedIn) {
        var firstLogin = window.localStorage.getItem("firstLogin" + this.props.auth.user.email);

        if (firstLogin === "true") {
          // this.tellUsProgramPopup();
        } else {
          window.localStorage.setItem("firstLogin" + this.props.auth.user.email, true);
        }
      }
      //End: Tell us popup Implementaiton. Do not show on first login and if Info required show popup.
      if (prevState._cookieNoticeDiscarded !== this.state._cookieNoticeDiscarded && this.state._cookieNoticeDiscarded) {
        var _subscribe = window.localStorage.getItem("_subscribe");
        if (!_subscribe) {
          setTimeout(function () {
            _this2.setState(function () {
              return { _subscribe: true };
            });
            window.localStorage.setItem("_subscribe", true);
          }, 1 * 1000);
        }
      }
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      return {
        location: this.props.location,
        params: this.props.params,
        auth: this.props.auth,
        user: this.props.user,
        dialogs: (0, _dialogs2.default)(this.handleDialogOpen.bind(this), this.handleDialogClose.bind(this))
      };
    }
  }, {
    key: "encodeString",
    value: function encodeString(str) {
      var value = 0;
      for (var i = 0; i < str.length; i++) {
        value += str.charCodeAt(i).toString();
      }
      return value;
    }
  }, {
    key: "handleSubscribePopupDiscard",
    value: function handleSubscribePopupDiscard(submit) {
      if (__CLIENT__) {
        if (submit) {
          clearInterval(this.subscribeInterval);
          window.localStorage.setItem("subscribed", true);
          this.setState({ subscribed: true });
        }

        window.localStorage.setItem("_subscribe", false);
        this.setState({ _subscribe: false });

        var subscriptionTime = window.localStorage.getItem("subscriptionTime");
        if (!subscriptionTime) window.localStorage.setItem("subscriptionTime", new Date());
      }
    }
  }, {
    key: "handleDialogOpen",
    value: function handleDialogOpen(component) {
      this.setState({
        dialogClosed: false,
        dialogComponent: component,
        pageOffset: _reactDom2.default.findDOMNode(this.refs.appWrap).getBoundingClientRect().top
      });
    }
  }, {
    key: "handleDialogClose",
    value: function handleDialogClose() {
      var _this3 = this;

      window.localStorage.setItem("promotionalPopupDiscard", true);
      this.setState({
        dialogClosed: true
      });

      setTimeout(function () {
        _this3.setState({
          dialogComponent: null
        });
      }, 100);
    }
  }, {
    key: "tellUsProgramPopup",
    value: function tellUsProgramPopup() {
      var _this4 = this;

      setTimeout(function () {
        return _this4.setState({
          dialogClosed: false,
          dialogComponent: _react2.default.createElement(_components.TellUsProgramContainer, {
            title: "Tell us a little more about you",
            description: "Please select your industry below.",
            tag: "WorkInfo",
            onCloseNo: _this4.handleDialogClose.bind(_this4),
            initialValues: {
              name: "",
              email: "",
              studio: "",
              title: "",
              url: "",
              artworkUrl: "",
              subject: "Indie Program Application",
              comments: "",
              checkBoxPc: "",
              checkBoxSmartPhone: "",
              checkBoxPlayStation: "",
              checkBoxXbox: "",
              checkBoxNitendo: "",
              checkBoxMac: "",
              checkBoxVr: "",
              checkBoxOther: "",
              select: "",
              teamSize: "",
              releaseDate: "",
              checkBoxFunding: "",
              checkBoxPublisher: ""
            }
          })
        }).bind(_this4);
      }, 3000);
    }
  }, {
    key: "handlePromotionalPopupDiscard",
    value: function handlePromotionalPopupDiscard() {
      if (__CLIENT__) {
        window.localStorage.setItem("promotionalPopupDiscard", true);
        this.setState({ promotionalPopupDiscard: true });
      }
    }
  }, {
    key: "handleCookieNoticeDiscard",
    value: function handleCookieNoticeDiscard() {
      if (__CLIENT__) {
        window.localStorage.setItem("_cookieNoticeDiscarded", true);
        this.setState({ _cookieNoticeDiscarded: true });
      }
    }
  }, {
    key: "showSubscribe",
    value: function showSubscribe() {
      if (__CLIENT__) {
        var subscriptionTime = window.localStorage.getItem("subscriptionTime");
        var _subscribe = window.localStorage.getItem("_subscribe");
        if (!subscriptionTime) {
          window.localStorage.setItem("subscriptionTime", new Date());
        } else {
          var d = Math.abs(new Date() - new Date(subscriptionTime)) / 1000; // delta
          var r = {}; // result
          var s = {
            // structure
            year: 31536000,
            month: 2592000,
            week: 604800, // uncomment row to ignore
            day: 86400, // feel free to add your own row
            hour: 3600,
            minute: 60,
            second: 1
          };

          (0, _keys2.default)(s).forEach(function (key) {
            r[key] = Math.floor(d / s[key]);
            d -= r[key] * s[key];
          });

          var week = window.localStorage.getItem("week");
          var month = window.localStorage.getItem("month");

          if ((r.week === parseInt(week) + 1 || r.month === parseInt(month) + 1) && _subscribe && _subscribe === "false" && this.state._cookieNoticeDiscarded) {
            if (r.month >= 1 && r.month <= 3 && r.week <= 0) {
              window.localStorage.setItem("month", parseInt(month) + 1);
              if (r.month > 1) {
                window.localStorage.setItem("_subscribe", true);
                this.setState({ _subscribe: true });
              }
            }
            if (r.week <= 4 && r.month <= 0) {
              window.localStorage.setItem("week", parseInt(week) + 1);
              window.localStorage.setItem("_subscribe", true);
              this.setState({ _subscribe: true });
            }
          }

          if (r.month === 3) {
            clearInterval(this.subscribeInterval);
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          router = _props.router,
          location = _props.location,
          packs = _props.packs,
          params = _props.params,
          notFound = _props.notFound;
      var _state = this.state,
          _cookieNoticeDiscarded = _state._cookieNoticeDiscarded,
          _subscribe = _state._subscribe,
          subscribed = _state.subscribed;


      var isModal = !!(location.state && location.state.modal && this.previousChildren);

      var nextTo = !!location.state ? location.state.nextTo : null;
      var previousTo = !!location.state ? location.state.previousTo : null;

      var currentType = params.type;

      var hasDialog = !!this.state.dialogComponent;
      var inLibrary = location.pathname.indexOf("/megascans/library") !== -1 || this.previousLocation && this.previousLocation.indexOf("/megascans/library") !== -1 || location.pathname.indexOf("/assets") !== -1;

      var navigateTo = !!location.state ? location.state.navigateTo : null;
      var showWhiteCloseBtn = !!location.state ? location.state.showWhiteCloseBtn : null;

      var children = notFound ? _react2.default.createElement(_NotFound2.default, null) : isModal ? (0, _reactAddonsCreateFragment2.default)({
        main: _react2.default.cloneElement(this.previousChildren, { behindAModal: true })
      }) : (0, _reactAddonsCreateFragment2.default)({
        main: _react2.default.cloneElement(this.props.children)
      });

      var info = !!location.state ? location.state.info : null;

      if (typeof dataLayer !== "undefined") {
        setTimeout(function () {
          dataLayer.push({ event: "optimize.activate" });
        }, 4000);
      }

      return _react2.default.createElement(
        _components.AppSideEffects,
        null,
        _react2.default.createElement(
          "div",
          { id: "react-app", className: styles && styles.App },
          _react2.default.createElement(_EpicPlansGotBetterBanner2.default, { router: router }),
          _react2.default.createElement(_components.SiteHeader, {
            behindAModal: isModal,
            isNewHome: false,
            location: location,
            dispatch: this.props.dispatch,
            packs: packs,
            currentType: currentType
          }),
          _react2.default.createElement(
            "div",
            { ref: "appWrap", style: { overflow: "hidden" } },
            children,
            !inLibrary ? _react2.default.createElement(_components.SiteFooter, { stateUpdated: this.state.resetSubscription }) : null
          ),
          isModal && _react2.default.createElement(
            _components.AppPopupContainer,
            {
              returnTo: this.previousLocation,
              previousTo: previousTo,
              nextTo: nextTo,
              info: info,
              navigateTo: navigateTo,
              showWhiteCloseBtn: showWhiteCloseBtn
            },
            this.props.children
          ),
          hasDialog ? _react2.default.createElement(
            _components.DialogContainer,
            { closed: this.state.dialogClosed },
            this.state.dialogComponent
          ) : null,
          !_cookieNoticeDiscarded && _react2.default.createElement(_CookieNotice2.default, {
            onDiscard: this.handleCookieNoticeDiscard.bind(this)
          }),
          _subscribe && _cookieNoticeDiscarded && !subscribed && _react2.default.createElement(_components.SubscribedNotice, {
            onClickHandler: function onClickHandler(email) {
              _this5.props.subscribeHubspot(email);
            },
            onDiscard: this.handleSubscribePopupDiscard.bind(this)
          }),
          _react2.default.createElement(_EpicLoginRedirectSensitiveOverlay2.default, null)
        )
      );
    }
  }]);
  return App;
}(_react.Component), _class2.childContextTypes = {
  location: _react2.default.PropTypes.object,
  params: _react2.default.PropTypes.object,
  auth: _react2.default.PropTypes.object,
  user: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object,
  router: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/App/App.jsx
// module id = 2083
// module chunks = 0